import React, { useState } from "react";
import { proporEntrevista, cancelarEntrevista, aceitarSugestaoEntrevista } from "../services/api";
import { abrirSala } from "../services/abrirSala";

// 📅 ENTREVISTA PELO SITE (17/10/2026) — lado da empresa, dentro da lista de candidaturas da vaga.
// Botão "Agendar entrevista" → a empresa propõe até 6 horários; o candidato escolhe; os dois recebem convite e link.
const quando = (iso) => new Date(iso).toLocaleString("pt-BR", { weekday: "short", day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
export const STATUS_ENTREVISTA = {
  proposta: { txt: "Aguardando o candidato escolher", cls: "bg-amber-100 text-amber-900" },
  confirmada: { txt: "Entrevista confirmada", cls: "bg-green-100 text-green-900" },
  realizada: { txt: "Entrevista realizada", cls: "bg-slate-100 text-slate-700" },
  cancelada: { txt: "Entrevista cancelada", cls: "bg-red-100 text-red-800" },
  expirada: { txt: "Ninguém escolheu a tempo", cls: "bg-slate-100 text-slate-600" },
};

export function SituacaoEntrevista({ e, onMudou, onRemarcar }) {
  if (!e) return null;
  const st = STATUS_ENTREVISTA[e.status] || { txt: e.status, cls: "bg-slate-100" };
  return (
    <div className="mt-2 rounded-xl border border-gray-200 bg-slate-50 p-2 text-xs">
      <span className={`rounded-full px-2 py-0.5 font-semibold ${st.cls}`}>📅 {st.txt}</span>
      {e.status === "confirmada" && e.inicio && <span className="ml-2 font-semibold">{quando(e.inicio)} · {e.duracaoMin} min</span>}
      {e.status === "proposta" && e.prazoEscolha && <span className="ml-2 text-gray-500">prazo para escolher: {quando(e.prazoEscolha)}</span>}
      {e.pedidoCandidatoEm && (
        <div className="mt-2 rounded-lg border border-amber-300 bg-amber-50 p-2">
          <div className="font-semibold text-amber-900">🙋 O candidato pediu outros horários <span className="font-normal text-gray-500">· {quando(e.pedidoCandidatoEm)}</span></div>
          {e.pedidoCandidato && <div className="italic text-gray-700 mt-0.5">“{e.pedidoCandidato}”</div>}
          {(e.pedidoSugestoes || []).length > 0 && (
            <div className="flex flex-wrap items-center gap-2 mt-1.5">
              <span className="text-gray-600">Sugeriu:</span>
              {e.pedidoSugestoes.map((h) => {
                const passou = new Date(h) <= new Date();
                return (
                  <button key={h} type="button" disabled={passou} title={passou ? "Este horário já passou" : "Confirmar a entrevista neste horário"}
                    onClick={async () => { if (window.confirm(`Confirmar a entrevista em ${quando(h)}? Os dois recebem o convite.`)) { await aceitarSugestaoEntrevista(e.id, h).catch((er) => window.alert(er.message)); onMudou(); } }}
                    className={`rounded-lg px-2.5 py-1 font-semibold border ${passou ? "bg-gray-100 text-gray-400 line-through border-gray-200" : "bg-green-600 hover:bg-green-700 text-white border-green-600"}`}>✓ {quando(h)}</button>
                );
              })}
            </div>
          )}
        </div>
      )}
      <div className="flex flex-wrap gap-2 mt-2">
        {e.link && <a href={e.link} onClick={(ev) => abrirSala(ev, e.link)} className="bg-brand text-white font-bold rounded-lg px-3 py-1">Entrar na sala</a>}
        {(e.linksOutros || []).map((o) => (
          <button key={o.link} type="button" onClick={() => navigator.clipboard && navigator.clipboard.writeText(o.link)}
            className="bg-white border border-gray-300 font-semibold rounded-lg px-3 py-1" title="Copia o link para mandar a esta pessoa">📋 Link de {o.nome}</button>
        ))}
        {e.podeMexer && e.status === "confirmada" && e.remarcacoesRestantes > 0 &&
          <button type="button" onClick={onRemarcar} className="bg-white border border-gray-300 font-semibold rounded-lg px-3 py-1">Remarcar</button>}
        {e.podeMexer && e.status === "proposta" &&
          <button type="button" onClick={onRemarcar} className="bg-white border border-gray-300 font-semibold rounded-lg px-3 py-1">Propor outros horários</button>}
        {e.podeMexer && <button type="button" onClick={async () => { if (window.confirm("Cancelar esta entrevista? O candidato será avisado.")) { await cancelarEntrevista(e.id).catch((er) => window.alert(er.message)); onMudou(); } }}
          className="text-red-600 font-semibold px-1">Cancelar</button>}
      </div>
    </div>
  );
}

export default function AgendarEntrevista({ vagaId, candidato, remarcar, onFechar, onAgendado }) {
  const amanha = new Date(Date.now() + 86400000); amanha.setMinutes(0, 0, 0); amanha.setHours(10);
  const fmt = (d) => new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
  const [horarios, setHorarios] = useState([fmt(amanha)]);
  const [duracao, setDuracao] = useState(45);
  const [outros, setOutros] = useState("");
  const [mensagem, setMensagem] = useState("");
  const [erro, setErro] = useState("");
  const [enviando, setEnviando] = useState(false);
  const enviar = async () => {
    setErro(""); setEnviando(true);
    try {
      await proporEntrevista(vagaId, candidato.usuarioId, {
        horarios: horarios.filter(Boolean).map((h) => new Date(h).toISOString()), duracaoMin: Number(duracao), mensagem,
        outrosEntrevistadores: outros.split(",").map((x) => x.trim()).filter(Boolean),
      });
      onAgendado();
    } catch (er) { setErro(er.message); }
    setEnviando(false);
  };
  return (
    <div className="fixed inset-0 z-[60] bg-black/50 flex items-center justify-center p-4" onClick={onFechar}>
      <div className="bg-white rounded-2xl shadow-xl max-w-lg w-full p-5 max-h-[90vh] overflow-y-auto text-sm" onClick={(e) => e.stopPropagation()}>
        <h3 className="font-bold text-lg text-text">{remarcar ? "Remarcar entrevista" : "Agendar entrevista"} com {candidato.nome}</h3>
        <p className="text-gray-500 text-xs mt-1">Proponha até 6 horários (horário de Brasília). {candidato.nome.split(" ")[0]} escolhe um em até 48 horas; confirmada,
          os dois recebem o convite na agenda e o link da sala de vídeo do eaiRH.{remarcar ? " Até a escolha, vale o horário já marcado." : ""}</p>
        <div className="mt-3 space-y-2">
          {horarios.map((h, i) => (
            <div key={i} className="flex gap-2">
              <input type="datetime-local" value={h} onChange={(e) => setHorarios(horarios.map((x, j) => (j === i ? e.target.value : x)))}
                className="flex-1 border rounded-lg px-2 py-1.5" />
              {horarios.length > 1 && <button type="button" onClick={() => setHorarios(horarios.filter((_, j) => j !== i))} className="px-2 text-gray-500">✕</button>}
            </div>
          ))}
          {horarios.length < 6 && <button type="button" onClick={() => setHorarios([...horarios, ""])} className="text-primary font-semibold text-xs">+ outro horário</button>}
        </div>
        <div className="grid grid-cols-2 gap-3 mt-3">
          <label className="text-xs text-gray-600">Duração
            <select value={duracao} onChange={(e) => setDuracao(e.target.value)} className="w-full border rounded-lg px-2 py-1.5 mt-1">
              {[20, 30, 45, 60, 90].map((m) => <option key={m} value={m}>{m} min</option>)}
            </select>
          </label>
          <label className="text-xs text-gray-600">Outros entrevistadores (opcional)
            <input value={outros} onChange={(e) => setOutros(e.target.value)} placeholder="Ex.: Ana, Bruno" className="w-full border rounded-lg px-2 py-1.5 mt-1" />
          </label>
        </div>
        <label className="block text-xs text-gray-600 mt-3">Recado para o candidato (opcional)
          <textarea value={mensagem} onChange={(e) => setMensagem(e.target.value)} rows={2} maxLength={600} className="w-full border rounded-lg px-2 py-1.5 mt-1"
            placeholder="Ex.: conversa de 45 min com a gestora da área; tenha o currículo em mãos." />
        </label>
        <p className="text-[11px] text-gray-400 mt-2">Com até 3 pessoas na sala o vídeo é direto e gratuito. Os outros entrevistadores recebem um link próprio, sem precisar de conta.</p>
        {erro && <p className="text-red-600 mt-2">{erro}</p>}
        <div className="flex justify-end gap-2 mt-4">
          <button onClick={onFechar} className="bg-slate-100 font-bold rounded-lg px-4 py-2">Voltar</button>
          <button disabled={enviando || !horarios.some(Boolean)} onClick={enviar} className="bg-accent text-white font-bold rounded-lg px-4 py-2 disabled:opacity-40">
            {enviando ? "Enviando…" : "Enviar horários"}</button>
        </div>
      </div>
    </div>
  );
}
